/* eslint-disable */
import { useState } from "react";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { putData } from "utils/Gateway";

import { assetImages } from "constants";

const UpdateTaskSchedulePopup = ({
  closePopupHandler = () => {},
  setUpdateScheduleTaskUserList = () => {},
  updateScheduleTaskUserList = [],
  reloadList = () => {},
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");

  const [startDate, setstartDate] = useState("");
  const [isUpdating, setisUpdating] = useState(false);

  const [validation, setValidation] = useState({
    startDate: false,
    workHours: {},
    workDays: {}, // New property for checkbox validation
  });

  //function for validation
  const validationHandler = () => {
    let isValid = true;

    //check start date is empty
    if (startDate === "") {
      setValidation((prevState) => ({ ...prevState, startDate: true }));
      isValid = false;
    }

    // Check if any workhours field is empty
    const workHoursErrors = {};
    updateScheduleTaskUserList.forEach((task, index) => {
      if (!task.workhours || task.workhours <= 0 || task.workhours === "") {
        workHoursErrors[index] = "Enter a valid work hour!";
        isValid = false;
      }
    });

    setValidation((prevState) => ({
      ...prevState,
      workHours: workHoursErrors,
    }));

    // Check if at least one day is selected for each user
    const daysErrors = {};

    updateScheduleTaskUserList.forEach((task, index) => {
      const daysChecked =
        task.Monday ||
        task.Tuesday ||
        task.Wednesday ||
        task.Thursday ||
        task.Friday ||
        task.Saturday ||
        task.Sunday;

      if (!daysChecked) {
        daysErrors[index] = "At least one day must be checked!";
        isValid = false;
      }
    });

    setValidation((prevState) => ({
      ...prevState,
      workDays: daysErrors,
    }));

    return isValid;
  };

  //function for change workhours
  const updateWorkHourHandler = (value, index) => {
    const newUpdatedTaskList = [...updateScheduleTaskUserList];
    const workHoursErrors = { ...validation.workHours };

    const rowIndex = newUpdatedTaskList.findIndex((task, idx) => idx === index);

    // Update the task's workhours if the task is found
    if (rowIndex !== -1) {
      newUpdatedTaskList[rowIndex] = {
        ...newUpdatedTaskList[rowIndex], // Keep other properties unchanged
        workhours: value, // Update the workhours property
      };
      setUpdateScheduleTaskUserList(newUpdatedTaskList);

      // Check if the input is valid
      if ((value && value > 0) || (value && value !== "")) {
        delete workHoursErrors[index]; // Clear validation error for this index
      } else {
        workHoursErrors[index] = "Enter a valid work hour!";
      }

      setValidation((prevState) => ({
        ...prevState,
        workHours: workHoursErrors,
      }));
    }
  };

  //function for change checkbox check
  const updateCheckBoxHandler = (checked = false, index, filedName = "") => {
    const newUpdatedTaskList = [...updateScheduleTaskUserList];

    const rowIndex = newUpdatedTaskList.findIndex((task, idx) => idx === index);

    // Update the task's workhours if the task is found
    if (rowIndex !== -1) {
      newUpdatedTaskList[rowIndex] = {
        ...newUpdatedTaskList[rowIndex], // Keep other properties unchanged
        [filedName]: checked, // Update the field property
      };

      setUpdateScheduleTaskUserList(newUpdatedTaskList);
    }

    // Validate days after updating
    const daysErrors = { ...validation.days };

    const daysChecked =
      newUpdatedTaskList[rowIndex].Monday ||
      newUpdatedTaskList[rowIndex].Tuesday ||
      newUpdatedTaskList[rowIndex].Wednesday ||
      newUpdatedTaskList[rowIndex].Thursday ||
      newUpdatedTaskList[rowIndex].Friday ||
      newUpdatedTaskList[rowIndex].Saturday ||
      newUpdatedTaskList[rowIndex].Sunday;

    // If no days are checked, set an error message for this index
    if (!daysChecked) {
      daysErrors[index] = "At least one day must be checked!";
    } else {
      delete daysErrors[index]; // Clear error if at least one day is checked
    }

    // Update validation state
    setValidation((prevState) => ({
      ...prevState,
      workDays: daysErrors,
    }));
  };

  //function for save schedule
  const saveTaskScheduleHandler = async () => {
    if (validationHandler()) {
      try {
        setisUpdating(true);

        let taskData = {
          startdate: startDate,
          usertaskschedulelist: updateScheduleTaskUserList,
        };

        let requestUrl =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_TASK_SCHEDULE +
          `?token=${token}`;

        let response = await putData(requestUrl, taskData);

        setisUpdating(false);

        if (response.status) {
          setMessageType("success");
          bootstrap.Offcanvas.getInstance(
            document.querySelector("#UpdateTaskSchedule")
          ).hide();

          resetHandler();
          reloadList();
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please enter required fields");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const resetHandler = () => {
    closePopupHandler();
    setUpdateScheduleTaskUserList([]);
    setstartDate("");
    setValidation({
      startDate: false,
      workHours: {},
      workDays: {},
    });
  };

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="UpdateTaskSchedule"
      aria-labelledby="UpdateTaskSchedule"
    >
      {/* Header design similar to SaveFeedbackRulePopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              calendar_month
            </span>{" "}
            {/* Using 'calendar_month' icon */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              Update Task Schedule
            </h3>
            <p className="text-white fs-sm mb-0">
              Manage and update task schedules for users
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {/* Professional Card Layout */}
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              <div className="table-wrapper form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="table-responsive mb-4">
                  <table className="table align-middle no-arrow fs-sm text-nowrap border-0 mb-0">
                    <thead>
                      <tr>
                        <th className="member bg-transparent fs-md fw-semibold border-0 text-dark">
                          Member
                        </th>
                        <th className="work-hours bg-transparent fs-md fw-semibold border-0 text-dark">
                          Working Hours / Day
                        </th>
                        <th
                          className="days bg-transparent fs-md fw-semibold border-0 text-dark"
                          colSpan="7"
                        >
                          Check the work days
                        </th>
                      </tr>
                    </thead>
                    {updateScheduleTaskUserList.length > 0 ? (
                      <tbody>
                        {updateScheduleTaskUserList.map(
                          (updatedScheduleUser, index) => {
                            return (
                              <tr key={index}>
                                <td className="member border-bottom-0">
                                  <div className="profile d-flex align-items-center gap-2">
                                    <div
                                      className="avatar rounded-circle overflow-hidden"
                                      style={{
                                        width: "2.188rem",
                                        height: " 2.188rem",
                                      }}
                                    >
                                      <img
                                        src={
                                          updatedScheduleUser.assigneduserimage ===
                                          ""
                                            ? assetImages.defaultUser
                                            : url.SERVER_URL +
                                              updatedScheduleUser.assigneduserimage
                                        }
                                        alt="userimage"
                                        className="w-100 h-100 object-fit-cover object-center"
                                      />
                                    </div>
                                    <div>
                                      <p className="fs-md fw-semibold mb-0 text-dark">
                                        {updatedScheduleUser.assignedusername ===
                                        ""
                                          ? "Unassigned"
                                          : updatedScheduleUser.assignedusername}
                                      </p>
                                      <p className="d-block lh-1 text-gray-600">
                                        {updatedScheduleUser.tasks?.length}{" "}
                                        tasks
                                      </p>

                                      {validation.workHours[index] && (
                                        <div className="error-message mt-2">
                                          <p className="d-flex align-items-center gap-1 text-danger">
                                            <span className="material-symbols-outlined icon-sm icon-fill">
                                              warning
                                            </span>
                                            <span>
                                              {validation.workHours[index]}
                                            </span>
                                          </p>
                                        </div>
                                      )}

                                      {validation.workDays[index] && (
                                        <div className="error-message">
                                          <p className="d-flex align-items-center gap-1 text-danger">
                                            <span className="material-symbols-outlined icon-sm icon-fill">
                                              warning
                                            </span>
                                            <span>
                                              {validation.workDays[index]}
                                            </span>
                                          </p>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </td>
                                <td className="work-hours border-bottom-0">
                                  <input
                                    type="number"
                                    className="form-control fs-sm shadow-none border border-gray-300"
                                    style={{ width: "6.25rem" }}
                                    value={updatedScheduleUser.workhours}
                                    onChange={(e) => {
                                      updateWorkHourHandler(
                                        e.target.value,
                                        index
                                      );
                                    }}
                                  />
                                </td>

                                <td className="days border-bottom-0">
                                  <div className="form-check d-flex align-items-center gap-2 fw-semibold p-0 m-0">
                                    <input
                                      type="checkbox"
                                      id={`mon-${index}`}
                                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0 cursor-pointer"
                                      checked={updatedScheduleUser.Monday}
                                      onChange={(e) => {
                                        updateCheckBoxHandler(
                                          e.target.checked,
                                          index,
                                          "Monday"
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer text-dark"
                                      htmlFor={`mon-${index}`}
                                    >
                                      Mon
                                    </label>
                                  </div>
                                </td>
                                <td className="days border-bottom-0">
                                  <div className="form-check d-flex align-items-center gap-2 fw-semibold p-0 m-0">
                                    <input
                                      type="checkbox"
                                      id={`tue-${index}`}
                                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0 cursor-pointer"
                                      checked={updatedScheduleUser.Tuesday}
                                      onChange={(e) => {
                                        updateCheckBoxHandler(
                                          e.target.checked,
                                          index,
                                          "Tuesday"
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer text-dark"
                                      htmlFor={`tue-${index}`}
                                    >
                                      Tue
                                    </label>
                                  </div>
                                </td>
                                <td className="days border-bottom-0">
                                  <div className="form-check d-flex align-items-center gap-2 fw-semibold p-0 m-0">
                                    <input
                                      type="checkbox"
                                      id={`wed-${index}`}
                                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0 cursor-pointer"
                                      checked={updatedScheduleUser.Wednesday}
                                      onChange={(e) => {
                                        updateCheckBoxHandler(
                                          e.target.checked,
                                          index,
                                          "Wednesday"
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer text-dark"
                                      htmlFor={`wed-${index}`}
                                    >
                                      Wed
                                    </label>
                                  </div>
                                </td>
                                <td className="days border-bottom-0">
                                  <div className="form-check d-flex align-items-center gap-2 fw-semibold p-0 m-0">
                                    <input
                                      type="checkbox"
                                      id={`thu-${index}`}
                                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0 cursor-pointer"
                                      checked={updatedScheduleUser.Thursday}
                                      onChange={(e) => {
                                        updateCheckBoxHandler(
                                          e.target.checked,
                                          index,
                                          "Thursday"
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer text-dark"
                                      htmlFor={`thu-${index}`}
                                    >
                                      Thu
                                    </label>
                                  </div>
                                </td>
                                <td className="days border-bottom-0">
                                  <div className="form-check d-flex align-items-center gap-2 fw-semibold p-0 m-0">
                                    <input
                                      type="checkbox"
                                      id={`fri-${index}`}
                                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0 cursor-pointer"
                                      checked={updatedScheduleUser.Friday}
                                      onChange={(e) => {
                                        updateCheckBoxHandler(
                                          e.target.checked,
                                          index,
                                          "Friday"
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer text-dark"
                                      htmlFor={`fri-${index}`}
                                    >
                                      Fri
                                    </label>
                                  </div>
                                </td>
                                <td className="days border-bottom-0">
                                  <div className="form-check d-flex align-items-center gap-2 fw-semibold p-0 m-0">
                                    <input
                                      type="checkbox"
                                      id={`sat-${index}`}
                                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0 cursor-pointer"
                                      checked={updatedScheduleUser.Saturday}
                                      onChange={(e) => {
                                        updateCheckBoxHandler(
                                          e.target.checked,
                                          index,
                                          "Saturday"
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer text-dark"
                                      htmlFor={`sat-${index}`}
                                    >
                                      Sat
                                    </label>
                                  </div>
                                </td>
                                <td className="days border-bottom-0">
                                  <div className="form-check d-flex align-items-center gap-2 fw-semibold p-0 m-0">
                                    <input
                                      type="checkbox"
                                      id={`sun-${index}`}
                                      name="sun"
                                      className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0 cursor-pointer"
                                      checked={updatedScheduleUser.Sunday}
                                      onChange={(e) => {
                                        updateCheckBoxHandler(
                                          e.target.checked,
                                          index,
                                          "Sunday"
                                        );
                                      }}
                                    />
                                    <label
                                      className="form-check-label cursor-pointer text-dark"
                                      htmlFor={`sun-${index}`}
                                    >
                                      Sun
                                    </label>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    ) : null}
                  </table>
                </div>
              </div>

              {/* <!-- ========== Start date Section ========== --> */}
              <div className="row">
                <div className="col-md-4 col-12 mb-4 mb-md-0">
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="startdate"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Start Date
                    </label>
                    <div className="field-container d-flex flex-column flex-lg-row gap-3 gap-lg-0 align-items-lg-center body-lg-bg rounded-10">
                      <input
                        type="date"
                        id="startdate"
                        className={`form-control fs-sm shadow-none ${
                          validation.startDate
                            ? "is-invalid"
                            : "border border-gray-300"
                        }`}
                        placeholder="Start Date"
                        value={startDate}
                        onChange={(e) => {
                          setstartDate(e.target.value);
                          setValidation((prevState) => ({
                            ...prevState,
                            startDate: false,
                          }));
                        }}
                      />
                    </div>
                    {/* <!-- ========== Start warning Section ========== --> */}
                    {validation.startDate && (
                      <div className="invalid-feedback d-block">
                        Please enter start date!
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- ========== End date Section ========== --> */}

            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveTaskScheduleHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isUpdating}
                style={{
                  cursor: isUpdating ? "not-allowed" : "pointer",
                }}
              >
                {isUpdating ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    Update Schedule
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateTaskSchedulePopup;
